import { WS_ENDPOINTS } from "./constants";

export function createEphemeralWebSocket(endpoint: keyof typeof WS_ENDPOINTS, ...pathParams: (string | number)[]) {
  let url = `${process.env.REACT_APP_SW_HOST}/ws/${WS_ENDPOINTS[endpoint]}`;
  if (pathParams.length) {
    url += "/" + pathParams.map(encodeURIComponent).join("/");
  }
  url += "/";

  return new WebSocket(url);
}
//
// export function createEphemeralWebSocket(endpoint: keyof typeof WS_ENDPOINTS, ...pathParams: (string | number)[]) {
//   let url = `${process.env.REACT_APP_SW_HOST}/ws/${WS_ENDPOINTS[endpoint]}`;
//   if (pathParams.length) {
//     url += "/" + pathParams.map(encodeURIComponent).join("/");
//   }
//   url += "/";
//   const ws = new WebSocket(url);
//
//   const event = new Promise<MessageEvent>((resolve, reject) => {
//     const timeout = setTimeout(() => {
//       ws.close();
//       reject(new Error("WebSocket timed out waiting for a response"));
//     }, 15000);
//
//     ws.onmessage = evt => {
//       clearTimeout(timeout);
//       ws.close();
//       resolve(evt);
//     };
//
//     ws.onerror = err => {
//       clearTimeout(timeout);
//       ws.close();
//       reject(err);
//     };
//   });
//
//   return { ws, event };
// }
